import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Col, Row } from "antd";
import classNames from "classnames";
import { FormFieldEditorFields } from "components/Forms/FormFieldEditorFields/FormFieldEditorFields";
import { DrawerLink } from "components/UI/DrawerLink";
import { useGeneralForm } from "components/UI/GeneralForm/hooks/useGeneralForm";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { useWatch } from "react-hook-form";
import { DrawerId } from "types/models";

import FormFieldData = App.Data.FormFieldData;

interface LocalFieldsEditorItemProps {
    index: number;
    onDelete: () => void;
    isDeleted: boolean;
}

export const LocalFieldsEditorItem: FC<LocalFieldsEditorItemProps> = ({ index, onDelete, isDeleted }) => {
    const { t } = usePaldockTranslation("forms.local-fields");
    const { control } = useGeneralForm();
    const formField = useWatch({ control, name: `formFields.${index}` }) as FormFieldData;
    const type = formField?.type;

    return (
        <Row gutter={10} align="middle" className={classNames(isDeleted && "opacity-50")}>
            <FormFieldEditorFields propertyPath={`formFields.${index}`} />
            <Col span={2}>
                <div className="flex w-full items-center justify-end gap-2">
                    {formField?.id ? (
                        <DrawerLink
                            drawerId={DrawerId.LocalFieldSettings}
                            search={{ [`${DrawerId.LocalFieldSettings}-formFieldId`]: formField.id }}
                            action="show"
                            disabled={!type}
                        >
                            <Button
                                type="text"
                                className="!bg-transparent !shadow-none"
                                disabled={!type}
                                icon={<EditOutlined />}
                                aria-label={t("actions.edit_settings")}
                            />
                        </DrawerLink>
                    ) : (
                        <Button
                            type="text"
                            className="!bg-transparent !shadow-none"
                            disabled
                            icon={<EditOutlined />}
                            aria-label={t("actions.edit_settings")}
                        />
                    )}
                    <Button
                        type="text"
                        className="!bg-transparent !shadow-none"
                        icon={<DeleteOutlined />}
                        aria-label={t("actions.delete")}
                        onClick={onDelete}
                    />
                </div>
            </Col>
        </Row>
    );
};
